import * as angular from 'angular';
import template from "./equipment-group.tpl.html";

export default angular
	.module('aps.directives.kpi', [])
	.directive('equipmentGroup', () => {
		return {
			replace: true,
			scope: {
				group: '=group'
			},
			template: template
		};
	})
	.name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/equipment-group.ts